module.exports = __webpack_public_path__ + "static/media/cloud-image.a3d97fad.svg";